import { Backdrop } from '@mui/material';
import { LottieLoadingAnimation } from 'features/loading-spinner/LottieLoadingAnimation';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { create } from 'zustand';

type GlobalAppBackdropStoreState = {
  isEnabled: boolean;
};

type GlobalAppBackdropStoreActions = {
  show: () => void;
  hide: () => void;
};

export const useGlobalAppBackdropStore = create<
  GlobalAppBackdropStoreState & GlobalAppBackdropStoreActions
>()(set => ({
  isEnabled: false,
  show: () => set({ isEnabled: true }),
  hide: () => set({ isEnabled: false }),
}));

export const useWrapInAppBackdrop = () => {
  const showGlobalBackdrop = useGlobalAppBackdropStore(state => state.show);
  const hideGlobalBackdrop = useGlobalAppBackdropStore(state => state.hide);

  return async <TReturn = void,>(callback: () => TReturn | Promise<TReturn>) => {
    showGlobalBackdrop();

    try {
      return await callback();
    } finally {
      hideGlobalBackdrop();
    }
  };
};

type Props = {
  children: ReactNode;
};

export const GlobalAppBackdrop = ({ children }: Props) => {
  const open = useGlobalAppBackdropStore(state => state.isEnabled);

  return (
    <>
      {children}

      <WhiteBackdrop open={open}>
        <LottieLoadingAnimation />
      </WhiteBackdrop>
    </>
  );
};

const WhiteBackdrop = styled(Backdrop)`
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ theme }) => theme.colors.backgroundDefault};
  z-index: 999999999999999;

`;
